module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLT-Medium.d1e92fe4.woff2";